import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/app/services/storage/storage.service';
import { UserService } from 'src/app/services/user/user.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard  {
  constructor(
    private userService: UserService,
    private router: Router,
    private storageService: StorageService
  ) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    const role = route.data.role.toUpperCase();
    return this.storageService.get('token').then((resToken) => {
      if (resToken) {
        return this.userService
          .getProfileWithOutToDoList('Y')
          .then((res: any) => {
            if (res.statusCode == 404) {
              this.router.navigate(['/404']);
            }
            if (res.statusCode == 401) {
              this.router.navigate(['']);
              return false;
            }            
            if (res.statusCode == 409) {
              this.router.navigate(['/verification']);
              return false;
            }
            if (res.statusCode == 200) {
              this.storageService.set('profile_photo', res.result[0].photo);
              this.storageService.set('luxandId', res.result[0].luxandId);
              //this.storageService.set('todoList', res.result[0].todoList);
              this.storageService.set(
                'name',
                res.result[0].firstName + ' ' + res.result[0].lastName
              );
              if (res.result[0].userType.toUpperCase() != role) {
                if (res.result[0].userType.toUpperCase() == 'STUDENT') {
                  this.router.navigate(['/student']);
                } else {
                  this.router.navigate(['/school']);
                }
              }
              return true;
            }
            return false;
          })
          .catch((err) => {
            this.storageService.clear();
            //location.reload();
            this.router.navigate(['']);
            return false;
          });
      } else {
        this.router.navigate(['']);
        return false;
      }
    });
  }
}
